import { j as r } from "../jsx-runtime-ClSzPYp4.js";
import { s as h } from "../index.esm-DOxVcNnO.js";
import { forwardRef as S, useRef as W, Children as q, isValidElement as $, cloneElement as L } from "react";
import { styled as c } from "styled-components";
import { color as b } from "styled-system";
import { Box as I, Flex as u, flexModifiers as f } from "../Flexbox/Flexbox.mjs";
import w from "../typography/Heading/Heading.mjs";
import v from "./ConnectionLines.mjs";
const F = /* @__PURE__ */ c(u).withConfig({
  componentId: "sc-ddce1e38-0"
})([
  "",
  " ",
  ""
], ({ theme: o }) => o.components.iconSummaryPanel.wrapper, f), R = /* @__PURE__ */ c(u).withConfig({
  componentId: "sc-ddce1e38-1"
})([
  "",
  " ",
  ""
], ({ theme: o }) => o.components.iconSummaryPanel.innerWrapper, f), V = /* @__PURE__ */ c(u).withConfig({
  componentId: "sc-ddce1e38-2"
})([
  "",
  " ",
  ""
], ({ theme: o }) => o.components.iconSummaryPanel.itemWrapper, f), k = /* @__PURE__ */ c.span.withConfig({
  shouldForwardProp: (o) => h(o)
}).withConfig({
  componentId: "sc-ddce1e38-3"
})([
  "",
  " ",
  ""
], ({ theme: o }) => o.components.iconSummaryPanel.iconWrapper, b), J = /* @__PURE__ */ S(({ children: o, colorVariant: l = "light", heading: t, headingSemanticLevel: a = "3", Icon: s, mobileLayoutVariant: i = "stacked", iconColor: p, ...m }, d) => {
  const e = m["data-qa-id"];
  return /* @__PURE__ */ r.jsxs(V, {
    colorVariant: l,
    mobileLayoutVariant: i,
    ...m,
    children: [
      /* @__PURE__ */ r.jsx(k, {
        ref: d,
        "data-qa-id": e && `${e}-icon-wrapper`,
        color: p,
        children: /* @__PURE__ */ r.jsx(s, {
          color: "currentColor",
          "data-qa-id": e && `${e}-icon`,
          size: "100%"
        })
      }),
      /* @__PURE__ */ r.jsx(I, {
        children: /* @__PURE__ */ r.jsxs(r.Fragment, {
          children: [
            t && /* @__PURE__ */ r.jsx(w, {
              level: a,
              size: "small",
              color: "currentColor",
              pb: [
                null,
                null,
                "xs"
              ],
              textAlign: "inherit",
              "data-qa-id": e && `${e}-heading`,
              children: t
            }),
            /* @__PURE__ */ r.jsx(I, {
              "data-qa-id": e && `${e}-content`,
              children: o
            })
          ]
        })
      })
    ]
  });
}), K = ({ children: o, colorVariant: l = "light", connected: t = !1, heading: a, headingSemanticLevel: s = "3", iconColor: i, mobileLayoutVariant: p = "stacked", innerWrapperProps: m, ...d }) => {
  const e = W([]), x = parseInt(s, 10), y = x < 6 ? `${x + 1}` : "6";
  return /* @__PURE__ */ r.jsxs(F, {
    ...d,
    children: [
      a && /* @__PURE__ */ r.jsx(w, {
        pb: 0,
        mb: "md",
        level: s,
        size: "small",
        color: "currentColor",
        children: a
      }),
      /* @__PURE__ */ r.jsxs(R, {
        ...m,
        children: [
          t && /* @__PURE__ */ r.jsx(v, {
            lineColor: i,
            elements: e.current
          }),
          q.map(o, (n, j) => {
            var g, C;
            return n && /* @__PURE__ */ $(n) && /* @__PURE__ */ L(n, {
              key: `icon-summary-panel-${j}`,
              ref: (P) => {
                e.current[j] = P;
              },
              colorVariant: ((g = n == null ? void 0 : n.props) == null ? void 0 : g.colorVariant) ?? t ? "light" : l,
              headingSemanticLevel: y,
              iconColor: ((C = n == null ? void 0 : n.props) == null ? void 0 : C.iconColor) ?? i,
              mobileLayoutVariant: t ? "condensed" : p
            });
          })
        ]
      })
    ]
  });
};
export {
  J as IconSummaryPanel,
  K as IconSummaryPanelList
};
